var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletbad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8334 16.4997V23.1663C29.8334 27.1663 27.1667 29.833 23.1667 29.833H9.83341C5.83341 29.833 3.16675 27.1663 3.16675 23.1663V16.4997C3.16675 12.873 5.35341 10.3397 8.75341 9.913C9.10008 9.85967 9.46008 9.83301 9.83341 9.83301H23.1667C23.5134 9.83301 23.8467 9.84632 24.1667 9.89966C27.6067 10.2997 29.8334 12.8463 29.8334 16.4997Z",
    stroke: "#008080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1685 9.90032C23.8485 9.84699 23.5151 9.83367 23.1685 9.83367H9.83513C9.46179 9.83367 9.10179 9.86034 8.75513 9.91367C8.94179 9.54034 9.20846 9.19367 9.52846 8.87367L13.8618 4.52699C15.6885 2.71366 18.6485 2.71366 20.4751 4.52699L22.8085 6.88702C23.6618 7.72702 24.1151 8.79366 24.1685 9.90032Z",
    stroke: "#008080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8332 17.167H25.8332C24.3665 17.167 23.1665 18.367 23.1665 19.8337C23.1665 21.3003 24.3665 22.5003 25.8332 22.5003H29.8332",
    stroke: "#008080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletbad);
export default __webpack_public_path__ + "static/media/walletbad.1ebf775d0f9443ae34c5e75a907b92c9.svg";
export { ForwardRef as ReactComponent };